import React from 'react';
import { MessageCircle } from 'lucide-react';
import { BRAND } from '../mock';

const FloatingWA = () => (
  <a href={BRAND.whatsapp} target="_blank" rel="noreferrer" className="fab-wa" aria-label="Chat WhatsApp">
    <MessageCircle className="w-7 h-7" />
  </a>
);

export default FloatingWA;
